export const DERATIZACIJA_V1_ResourcesBS: DERATIZACIJA_V1_ResourcesBSInterface =
  {
    labelDone: "Datum obavljanja zadatka",
    errors: {
      registerPic: "The picture you are uploading is too large.",
      recordAlreadyExists:
        "Ova evidencija je već popunjena. Ne možete je popuniti ponovo.",
    },
    evidencijaForm: {
      buttonForward: "Potpisi",
      buttonBack: "Nazad",
    },
    successModal: {
      title: "Unos podataka",
      body: "Dodavanje podataka je uspješno završeno. Odaberite OK za nastavak.",
      buttonOk: "OK",
    },
    txtPotvrda:
      "Odabirom opcije Potpiši potvrđujem da je zadatak izvršen prema uputstvu!",
    profilePicture: {
      label: "Slike",
      name: "profilePicture",
      error: "Please select your profile picture",
      validation: "Wrong profile picture",
      description: () => (
        <>
          <h4> files here or click to upload.</h4>
          <span className="text-muted font-13">Only images, max 6MB</span>
        </>
      ),
    },
    errorMissingInput: "Molimo popunite sva polja",
    kontrola: {
      checkboxLabel: "Infestacija glodarima",
      opisKontrole: "Opis kontrole",
      errorOpisKontrole: "Unos opisa kontrole je obavezan",
    },
    korekcija: {
      stanjeKorekcije: "Stanje korekcije",
      opisKorekcije: "Opis korekcije",
    },
  };

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface ProfilePicture {
  label: string;
  name: string;
  error: string;
  validation: string;
  description: () => JSX.Element;
}

interface Kontrola {
  checkboxLabel: string;
  opisKontrole: string;
  errorOpisKontrole: string;
}

interface Korekcija {
  stanjeKorekcije: string;
  opisKorekcije: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface DERATIZACIJA_V1_ResourcesBSInterface {
  labelDone: string;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  profilePicture: ProfilePicture;
  errorMissingInput: string;
  kontrola: Kontrola;
  korekcija: Korekcija;
  errors: IErrors;
}
